<template>
    <div>
        <h3 class="mb-3">Expediente</h3>
        <b-card>            
            <alert
                :variant="alert.variant"            
                dismissible
                :mensagens="alert.mensagens"
                :value="alert.exibir"
                @input="alertDismissed"
            >
            </alert> 

            <b-row class="mb-3">
                <b-col>
                    <editor      
                        v-model="content"
                        :init="{                               
                        language: 'pt_BR',
                        license_key: 'gpl',
                        base_url: '/js/tinymce',
                        height: 550,
                        menubar: false,
                        branding: false,
                        paste_as_text: false,
                        paste_merge_formats: true,
                        plugins: [
                            'lists',
                            'autolink',
                            'link',
                            'preview',
                            'searchreplace',
                            'table',
                            'wordcount',
                        ],
                        toolbar: [
                            'bold italic underline strikethrough fontfamily blocks fontsize forecolor backcolor bullist numlist subscript superscript removeformat',
                            'alignleft aligncenter alignright alignjustify outdent indent table link undo redo preview customUploadWord'
                        ], 
                        setup: function(ed) {
                            ed.on('keydown', function(event) {
                                if (event.keyCode == 9) { // tab pressed
                                    if (event.shiftKey) {
                                    ed.execCommand('Outdent');
                                    }
                                    else {
                                    ed.execCommand('Indent');
                                    }

                                    event.preventDefault();
                                    return false;
                                }
                            });
                        }
                    }"
                />  
                </b-col>
            </b-row>
            <b-row>
                <b-col class="text-right">
                    <b-button 
                        variant="success"
                        @click="salvar">
                        <i class="fa fa-floppy-o pr-1"></i> Salvar
                     </b-button>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>

import Alert from '../../../models/Alert'
import editor from '@tinymce/tinymce-vue';

export default {

    components: {
        editor
    },

    data(){
        return {                                                
            content: null,
            id: null,            
            alert: new Alert(),  
        }
    },

    methods: {

        alertDismissed(){           
            this.alert= new Alert();
        },

        listar() {         
            this.$api.expediente.listar()
            .then(response => {                                   
                if(response.status == 200 || response.status == 201){               
                    if(response.data && response.data.length != 0){
                        this.content = response.data.data.conteudo;
                        this.id      = response.data.data.id;                                                     
                    }                                                                             
                }
            })
            .catch(error => {
                this.$helper.showAlert(this.alert, 
                                       this.$constantes.alert.variants.DANGER,
                                       error.response.data.errors);                                               
            });
        },

        salvar() {                    
            //Retira as tags de paragrafo e quebra de linha para verificar se o conteudo esta vazio 
            let contentAux = this.content.replace(/<br>/g,'')
                                         .replace(/<p>/g,'')
                                         .replace(/<p class="ql-align-justify">/g,'')
                                         .replace(/<\/p>/g,'')
                                         .trim();

            if(contentAux === ""){    
                this.$helper.showAlert(this.alert, 
                                       this.$constantes.alert.variants.DANGER,
                                       'O campo expediente é obrigatório.');                
                return;     
            }

            this.$api.expediente.salvar({ id: this.id, conteudo: this.content })
            .then(response => {          
                if(response.status == 200 || response.status == 201){ 
                    this.content = response.data.data.conteudo;
                    this.id      = response.data.data.id;
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.SUCCESS,
                                           'Registro atualizado com sucesso!');                     
                }
            })
            .catch(error => {
                this.$helper.showAlert(this.alert, 
                                       this.$constantes.alert.variants.DANGER,
                                       error.response.data.errors);                 
            });
        },

    },
    
    mounted(){ 
        this.listar();          
    },

    
}
</script>

